<div *ngIf="!success">
    <h1 [innerHTML]="'forgotPassword.title' | translate"></h1>
    <p class="large" [innerHTML]="'forgotPassword.intro' | translate"></p>
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <div class="forgot-password-wrapper">
            <div class="form-group" [class.active]="hasFocus || hasValue(f.username)" [class.hasvalue]="!hasFocus && hasValue(f.username)">
                <label
                    for="username"
                    [class.active]="hasFocus || hasValue(f.username)"
                    [class.hasvalue]="!hasFocus && hasValue(f.username)"
                >
                    <span class="labelcontent"><span [innerHTML]="'forgotPassword.username' | translate"></span></span>
                    <input formControlName="username" id="username" (focus)="hasFocus = true" (blur)="hasFocus = false" type="text" />
                </label>
                <div *ngIf="submitted && (f.username.errors || showMessage)" class="invalid-feedback">
                    <div
                        *ngIf="f.username.errors && f.username.errors.required"
                        [innerHTML]="'forgotPassword.usernameRequired' | translate"
                    ></div>
                    <div
                        *ngIf="f.username.errors && f.username.errors.pattern"
                        [innerHTML]="'forgotPassword.emailFormat' | translate"
                    ></div>
                </div>
            </div>
            <div class="form-group button-wrapper">
                <a [routerLink]="linkLoginForm" class="secondary button" da-link
                    ><span [innerHTML]="'forgotPassword.cancel' | translate"></span
                ></a>
                <button [disabled]="loaded$ | async" class="button primary">
                    <span [innerHTML]="'forgotPassword.submit' | translate"></span>
                </button>
            </div>
            <div *ngIf="showMessage" class="error-message">
                <div [innerHTML]="'forgotPassword.errorMessage' | translate"></div>
            </div>
        </div>
    </form>
</div>
<ng-container *ngIf="success">
    <div class="success">
        <h1 [innerHTML]="'forgotPassword.titleSuccess' | translate"></h1>
        <p class="large" [innerHTML]="('forgotPassword.messageSuccess' | translate).replace('username', f.username.value)"></p>
    </div>
</ng-container>
